import request from "@/utils/request";

// 获取个人信息
export const getUserInfoDetail = (config = {}) => {
  return request.get("/api/mts-api/user/getUserInfo", config);
};

// 获取个人余额
export const getUserBalance = () => {
  return request.get("/api/mts-api/user/getUserBalance");
};

// 使用账户余额偿还信用金额
export const balanceCovertCredit = (data) => {
  return request.post("/api/mts-api/user/balanceCovertCredit", data);
};

// 获取个人奖励明细
export const getMyRewardList = () => {
  return request.get("/api/mts-api/user/getMyRewardList");
};

// 获取余额流水记录
export const getBalanceRecord = () => {
  return request.get("/api/mts-api/user/getBalanceRecord");
};

// 提交提现申请
export const submitWithdrawApply = (data) => {
  return request.post("/api/mts-api/user/balance/withdraw/apply", data);
};

// 获取最近的提现记录
export const getWithdrawRecordList = (data) => {
  return request.get("/api/mts-api/user/balance/withdraw/list", {
    params: data,
  });
};

// 审核提现申请
export const auditWithdrawApply = (data) => {
  return request.post("/api/mts-api/user/balance/withdraw/audit", data);
};

// 获取提现审核记录
export const getWithdrawAuditRecord = (id) => {
  return request.get("/api/mts-api/user/balance/withdraw/getAuditRecord", {
    params: { id },
  });
};

// 财务提交提现付款凭证
export const submitWithdrawPayment = (data) => {
  return request.post("/api/mts-api/user/balance/withdraw/submitPayment", data);
};

// 用户确认收到提现款项
export const confirmWithdrawReceipt = (data) => {
  return request.post("/api/mts-api/user/balance/withdraw/confirmReceipt", data);
};

export const getMyCustomers = () => {
  return request.get("/api/mts-api/user/myCustomers");
};

export const getMySalesperson = () => {
  return request.get("/api/mts-api/user/mySalesperson");
};

export const getUserBaseInfo = (mobile) => {
  return request({
    url: "/api/mts-api/user/getUserBaseInfo",
    method: "get",
    params: {
      mobile,
    },
  });
};

export function updateUserInfo(data) {
  return request({
    url: '/api/mts-api/user/updateInfo',
    method: 'post',
    data: data
  })
}
